var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportTickets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 96,
    viewBox: "0 0 79 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_205_4669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.10467 48.5371L35.2503 24.9224L69.3959 48.5371",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.10467 48.5371L35.2503 24.9224L69.3959 48.5371",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17164 52.9269L35.2581 32.8069L64.7337 53.1915",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17164 52.9268V89.493H64.7337V53.1914",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3959 48.5371L35.2503 72.1518L1.10467 48.5371V95.7666H69.3959V48.5371Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.78 82.0679H48.1551V89.1507H62.78V82.0679Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1848 23.1866L4.26472 12.2588",
    stroke: "#1F2025",
    strokeWidth: 0.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2219 29.8413H43.9365C42.8858 29.8413 42.0296 30.6975 42.0296 31.7482V59.566L48.6143 52.9812H76.2219C77.2727 52.9812 78.1288 52.1251 78.1288 51.0743V31.7482C78.1288 30.6975 77.2727 29.8413 76.2219 29.8413Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0714 42.6917H60.087",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.913 42.6917H66.9364",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3855 42.6917H53.4011",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2503 15.668V0.22583",
    stroke: "#1F2025",
    strokeWidth: 0.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2576 23.1867L67.1776 12.2666",
    stroke: "#1F2025",
    strokeWidth: 0.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_4669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.2577,
    height: 96,
    fill: "white",
    transform: "translate(0.87117)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportTickets);
export default __webpack_public_path__ + "static/media/support_tickets.2fd30f1c5b6c384c5e353e7f2728c73c.svg";
export { ForwardRef as ReactComponent };